import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons'; // Adjust the import path as per your project structure
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class OtpService extends ApiService {

 
    async sendOtp(): Promise<any> {
        const response = await this.post("/v1/otp/send-sms");
        return response.data;
    }
 
    async verifyOtp(code: string): Promise<any> {
        let queryParameters = new HttpParams()
            .set('code', code)
        const response = await this.post("/v1/otp/verify-sms", undefined, queryParameters);
        return response
    }

    async sendSmsLink(){
        const response = await this.post('/v1/otp/send-sms-link');
        return response.data;
      }
    
      async verifySmsLink(token: string){
        let queryParameters = new HttpParams().set('token', token)
        return await this.post('/v1/otp/verify-sms-link', queryParameters);
      }

}
